import {
  OnboardingLaunchConditionResult,
  OnboardingLaunchConditions
} from './types';
import { ONBOARDING_MAX_SHOWS } from '../onboardingStorage';

export const getOnboardingLaunchConditions = (
  conditions: OnboardingLaunchConditions
): OnboardingLaunchConditionResult => {
  const {
    hasOrganization,
    isAuthenticated,
    isBlockingInterfaceOpen,
    isHandledInSession,
    isProfileError,
    isProfileLoading,
    isProfileSuccess,
    isShipmentsError,
    isShipmentsLoading,
    isShipmentsSuccess,
    pathname,
    shipmentCount,
    storageState,
    userId
  } = conditions;

  let blockReason: OnboardingLaunchConditionResult['blockReason'] = null;

  if (!isAuthenticated) {
    blockReason = 'AUTH_REQUIRED';
  } else if (!userId?.trim()) {
    blockReason = 'USER_ID_MISSING';
  } else if (pathname !== '/') {
    blockReason = 'NOT_MAIN_ROUTE';
  } else if (isProfileError) {
    blockReason = 'PROFILE_ERROR';
  } else if (isProfileLoading || !isProfileSuccess) {
    blockReason = 'PROFILE_LOADING';
  } else if (hasOrganization && isShipmentsError) {
    blockReason = 'SHIPMENTS_ERROR';
  } else if (hasOrganization && (isShipmentsLoading || !isShipmentsSuccess || shipmentCount === null)) {
    blockReason = 'SHIPMENTS_LOADING';
  } else if (hasOrganization && (shipmentCount ?? 0) > 0) {
    blockReason = 'SHIPMENTS_PRESENT';
  } else if (storageState.isCompleted) {
    blockReason = 'COMPLETED';
  } else if (storageState.shownCount >= ONBOARDING_MAX_SHOWS) {
    blockReason = 'LIMIT_REACHED';
  } else if (isHandledInSession) {
    blockReason = 'SESSION_ALREADY_HANDLED';
  } else if (isBlockingInterfaceOpen) {
    blockReason = 'BLOCKING_INTERFACE_OPEN';
  }

  return {
    blockReason,
    isEligible: blockReason === null,
    shouldCompleteOnboarding: blockReason === 'SHIPMENTS_PRESENT'
  };
};